import React from 'react';
import { Input, Modal, Table, message, Button } from 'antd';
import { NotificationOutlined } from '@ant-design/icons'
import { columns } from './columns';
import axios from 'axios';
import _ from 'lodash';

const { TextArea } = Input;

const ApplicationTable = ({data, status}) => {
  const inputRef = React.useRef(null);
  const [col, setCol] = React.useState(columns)
  const [selectedAppIds, setSelectedAppIds] = React.useState([])
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    let newCol = col

    if (!['created', 'hr_valid'].includes(status)) {
      newCol = _.reject(newCol, { title: 'Tags' })
    }

    if (!['in_progress', 'wait_confirm', 'approved', 'loan_closed'].includes(status)) {
      newCol = _.reject(newCol, { dataIndex: 'lms_app_id' })
    }

    if (!['approved', 'loan_closed'].includes(status)){
      newCol = _.reject(newCol, { dataIndex: 'lms_loan_id' })
    }

    if (status !== 'rejected'){
      newCol = _.reject(newCol, { dataIndex: 'reject_reason' })
    }

    if (status !== 'wait_confirm') {
      newCol = _.reject(newCol, { dataIndex: 'payment_status' })
    }

    /// Any status since "ส่งใบสมัครไปยัง LMS แล้ว" and after should not see the user score anymore
    const statusesToHideScores = ['in_progress', 'wait_confirm', 'approved', 'loan_closed', 'rejected', 'cancelled'];

    if (statusesToHideScores.includes(status)) {
      newCol = newCol.filter(col => !['current_score', 'last_month_score'].includes(col.key));
    }

    _.last(newCol).title = () => <NotificationOutlined onClick={() => setOpen(true)} />

    setCol(newCol)
  }, [status]);

  const sendLineMsg = () => {
    const application_ids = selectedAppIds
    const msg = inputRef.current.resizableTextArea.textArea.value

    setLoading(true);
    axios.post('/admins/applications/line_msg', {
      application_ids,
      msg
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      message.success('success')
      setOpen(false)
    }).catch((error) => {
      message.error('error')
    }).finally(() => {
      setLoading(false);
    })
  }

  const sendLineMsgAll = () => {
    const msg = inputRef.current.resizableTextArea.textArea.value
    setLoading(true);
    axios.post(`/admins/applications/line_msg${window.location.search}`, {
      application_ids: 'send_all',
      msg
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      message.success('success')
      setOpen(false)
    }).catch((error) => {
      message.error('error')
    }).finally(() => {
      setLoading(false);
    })
  }

  return (
    <>
      <Modal
        title={`ส่ง Line ไปที่เจ้าของ Application ID: ${selectedAppIds.join(', ')}`}
        open={open}
        onCancel={() => setOpen(false)}
        confirmLoading={loading}
        footer={[
          <Button key='cancel' onClick={() => setOpen(false)}>
            Cancel
          </Button>,
          <Button key='ok' type="primary" onClick={sendLineMsg} disabled={_.isEmpty(selectedAppIds)} >
            Send Selected
          </Button>,
          <Button key="send_all" type="danger" onClick={sendLineMsgAll}>
            Send All
          </Button>,
        ]}
      >
        <TextArea ref={inputRef}/>
      </Modal>
      <Table
        rowSelection={{
          type: 'checkbox',
          onChange: setSelectedAppIds
        }}
        rowClassName={(app) => (app.row_class)}
        columns={col}
        dataSource={data}
        pagination={false}
      />
    </>

  );
};
export default ApplicationTable;
